import httpService from '@/core/services/http.service.js';
import clientMapper from '@/core/services/helpers/clientMapper.js';

// action types
export const GET_PHYSICAL_ENTITIES_CLIENTS_MODULE = 'getPhysicalEntitiesClientsModule';
export const GET_LEGAL_ENTITIES_CLIENTS_MODULE = 'getlegalEntitiesClientsModule';

// mutations types
export const SET_PHYSICAL_ENTITIES_CLIENTS_MODULE = 'setPhysicalEntities';
export const SET_LEGAL_ENTITIES_CLIENTS_MODULE = 'setLegalEntities';

const state = {
  physicalEntities: [],
  legalEntities: [],
};

const getters = {
  physicalEntitiesOptions(state) {
    return state.physicalEntities;
  },
  legalEntitiesOptions(state) {
    return state.legalEntities;
  },

  getClient: (state) => (id) => state.clients.find((client) => client.id === id),

  clientsAsOptions(state) {
    return clientMapper.mapClientsAsOptions(state.clients);
  },
};

const actions = {
  [GET_PHYSICAL_ENTITIES_CLIENTS_MODULE](context) {
    httpService.get('/api/b2b/physical-entities/subject-create').then((response) => {
      context.commit(SET_PHYSICAL_ENTITIES_CLIENTS_MODULE, response.data.data);
    });
  },
  [GET_LEGAL_ENTITIES_CLIENTS_MODULE](context) {
    httpService.get('/api/b2b/legal-entities/subject-create').then((response) => {
      context.commit(SET_LEGAL_ENTITIES_CLIENTS_MODULE, response.data.data);
    });
  },
};

const mutations = {
  [SET_PHYSICAL_ENTITIES_CLIENTS_MODULE](state, physicalEntities) {
    state.physicalEntities = physicalEntities;
  },
  [SET_LEGAL_ENTITIES_CLIENTS_MODULE](state, legalEntities) {
    state.legalEntities = legalEntities;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
